// src/cubing/search/inside/worker-guard.ts
var exposeAPI = {
  expose: true
};

export {
  exposeAPI
};
//# sourceMappingURL=chunk-RHC3DIN3.js.map
